import React from 'react';
import ReactDOM from 'react-dom';

class NameFilter extends React.Component {
  constructor(props) { 
    super(props); 
  }
   
  render() {

    return (
      <div className='mb-2'>
        <h5>{this.props.title}</h5>
        {/* <hr className="mt-0 mb-1 py-0"/> */}
        {/* <div className="col-12"> */}
        <div  >
            {this.props.children}
        </div>
      </div>

    );
  }
}
export default NameFilter;

